<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">
    <shared-forms-input [compact]="compact" [errors]="error$ | async" [parentForm]="formControl" type="password"
        name="password" [label]="labelPassword">
    </shared-forms-input>

    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="receivePromo" [required]="false"
        [label]="labelReceivePromo" type="checkbox">
    </shared-forms-input>


    <ng-template #left>
        <shared-forms-terms (onClick)="handleTermsClick($event)"></shared-forms-terms>
    </ng-template>

    <ng-template #right>
        <shared-forms-submit [loading]="loading$ | async" marginTop="none" width="normal" [parentForm]="formControl">
            Create account
        </shared-forms-submit>
    </ng-template>

    <shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
    </shared-forms-offset-wrapper>
</form>